module.exports = __webpack_public_path__ + "static/media/box2.c57157d6.svg";